// extracted by mini-css-extract-plugin
module.exports = {"customersContainer":"customers_customersContainer__07_mj","customerContainer":"customers_customerContainer__kUG_m"};